/* eslint max-len: 0 */
export const messages = {
  accountSettings: {
    title: {
      id: 'accountSettings.Page.Title',
      defaultMessage: 'Account Settings',
    },
    state: {
      accessEnabled: {
        id: 'accountSettings.State.Access.Enabled',
        defaultMessage: 'This contact is authorized to access your information.',
      },
      accessDisabled: {
        id: 'accountSettings.State.Access.Disabled',
        defaultMessage: 'This contact is authorized to access your information, but their account access is disabled.',
      },
      lockAccount: {
        id: 'accountSettings.State.LockAccount',
        defaultMessage: 'This contact is authorized to access your information, but their account is locked.',
      },
      noUserAccount: {
        id: 'accountSettings.State.NoUserAccount',
        defaultMessage: 'This contact has not been invited to the patient portal and cannot access your health information.',
      },
      invitedContactMessage: {
        id: 'accountSettings.State.InvitedContact',
        defaultMessage: 'This contact has been invited to the portal, but has not yet created an account.',
      },
    },
    button: {
      resetPassword: {
        id: 'accountSettings.Button.ResetPassword',
        defaultMessage: 'Reset Password',
      },
      enableAccess: {
        id: 'accountSettings.Button.EnableAccess',
        defaultMessage: 'Enable Access',
      },
      disableAccess: {
        id: 'accountSettings.Button.DisableAccess',
        defaultMessage: 'Disable Access',
      },
      deleteContact: {
        id: 'accountSettings.Button.DeleteContact',
        defaultMessage: 'Delete Contact',
      },
      inviteContact: {
        id: 'accountSettings.Button.Invite',
        defaultMessage: 'Invite Contact',
      },
      reinviteContact: {
        id: 'accountSettings.Button.Reinvite',
        defaultMessage: 'Resend Invitation',
      },
      hint: {
        id: 'accountSettings.Button.Hint',
        defaultMessage: 'Clicking on this button, opens a new dialog.',
      },
      unlock: {
        id: 'accountSettings.Button.Unlock',
        defaultMessage: 'Unlock',
      },
    },
    label: {
      username: {
        id: 'accountSettings.Label.UserName',
        defaultMessage: 'Username:',
      },
    },
  },
};
